import { render } from "./CategoryList.vue?vue&type=template&id=1a949da8&scoped=true&ts=true"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"

import "./CategoryList.vue?vue&type=style&index=0&id=1a949da8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a949da8"]])

export default __exports__